import { defineComponent } from "../../../common/runtime/defineComponent.svelte.ts";
import { iconRegistryStyles } from "../../../scss/icon/iconRegistryStyles.ts";
import type { Props } from "./IconButtonV4.types.ts";
import component from "./IconButtonV4.svelte";

defineComponent<Props>({
  tag: "oc-icon-button-v4",
  extendOptions: {},
  styles: [iconRegistryStyles, () => import("./IconButtonV4.global.scss?inline")],
  props: {
    elevationLevel: { attribute: "elevation-level", reflect: true },
    hideTooltip: { attribute: "hide-tooltip", type: "Boolean", reflect: true },
    icon: { reflect: true },
    loading: { type: "Boolean", reflect: true },
    size: { reflect: true },
    success: { type: "Boolean", reflect: true },
    variant: { reflect: true },
  },
  component: () => component,
});
